"use client";
import { useContext } from "react";
import { PrismicGlobalConfigContext } from "@sendmagic/prismic-nextjs/src/context/prismic-global-config";

const useGlobalContext = () => useContext(PrismicGlobalConfigContext);

export default useGlobalContext;
